import { render, staticRenderFns } from "./addTaskPageWithParam.vue?vue&type=template&id=616699a2&scoped=true&"
import script from "./addTaskPageWithParam.vue?vue&type=script&lang=tsx&"
export * from "./addTaskPageWithParam.vue?vue&type=script&lang=tsx&"
import style0 from "./addTaskPageWithParam.vue?vue&type=style&index=0&id=616699a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616699a2",
  null
  
)

export default component.exports